import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Order } from 'src/app/modules/shared/models/orders.model';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { StoreDetailService } from 'src/app/modules/shared/services/resolver/store-detail.service';
import { SnackBarService } from 'src/app/modules/shared/services/snack-bar.service';
import { OrderDetailComponent } from '../order-detail/order-detail.component';
import { FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LocalStorageService } from 'src/app/modules/shared/services/storage/local-storage.service';
import { PaginationService } from 'src/app/modules/shared/services/pagination/pagination.service';
import { DeviceDetectorService } from 'src/app/modules/shared/services/device-detector/device-detector.service';
import { BinanceService } from 'src/app/modules/shared/services/binance/binance.service';

@Component({
  selector: 'app-shop-summary',
  templateUrl: './shop-summary.component.html',
  styleUrls: ['./shop-summary.component.scss'],
})
export class ShopSummaryComponent implements OnInit {
  products: Order[] = [];
  storeDetail: any;
  shareLink = '';
  filterForm: FormGroup;
  isListEmpty: boolean = false;
  isFilterFormCalled: boolean = false;
  isLoggedIn: boolean;
  nextpage: string;
  isDesktop: boolean = false;

  @ViewChild('shareLinkDialog') shareLinkDialog: any;
  @ViewChild('filterOrdersBottomSheet')
  filterOrdersBottomSheet: TemplateRef<any>;
  @ViewChild('filterOrdersDialog') filterOrdersDialog: TemplateRef<any>;
  displayedColumns: string[] = [
    'title',
    'order_id',
    'date',
    'status',
    'actions',
  ];
  constructor(
    private panelService: PanelService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private storeDetailResolver: StoreDetailService,
    private datePipe: DatePipe,
    private router: Router,
    private clipboard: Clipboard,
    private bottomSheet: MatBottomSheet,
    private localStorage: LocalStorageService,
    private paginationService: PaginationService,
    private binanceService: BinanceService,
    private deviceDetectorService: DeviceDetectorService
  ) {
    this.isDesktop = this.deviceDetectorService.isDesktop;
  }

  ngOnInit(): void {
    if (this.localStorage.isLoggedIn) {
      this.isLoggedIn = true;
      this.initForm();
      this.getOrderList();
      this.storeDetail = this.storeDetailResolver.permissionInit;
    }
  }

  initForm() {
    this.filterForm = new FormGroup({
      created_time__date: new FormControl(''),
    });
  }

  getOrderList() {
    let form = this.filterForm.value;
    let created_time__date = this.datePipe.transform(
      form.created_time__date,
      'YYYY-MM-dd'
    );
    let filter = {
      limit: 20,
      offset: 0,
      ordering: '-id',
    };
    if (created_time__date) {
      filter['created_time__date'] = created_time__date;
    }
    this.panelService.getOrderList(filter).subscribe((products) => {
      if (products.results?.length == 0) {
        this.isListEmpty = true;
      } else this.isListEmpty = false;

      this.products = products.results;
      this.nextpage = products.next;
      this.paginationService.setNextPageMethod(this.getPage.bind(this));
    });
  }

  getPage() {
    if (this.nextpage != null) {
      this.paginationService.fetchNextData(this.nextpage).subscribe((list) => {
        this.nextpage = list.next;
        this.products = [...this.products, ...list.results];
        if (list.results?.length == 0) {
          this.isListEmpty = true;
        } else this.isListEmpty = false;
      });
      this.nextpage = null;
    }
  }

  orderAgain(productId) {
    this.panelService.resendOrder(productId).subscribe((res) => {
      this.snackBarService.showSnackBar(res.detail, 'primary', 3000);
    });
  }

  completePurchase(redirectUrl: string) {
    if (!redirectUrl) return;
    window.location.href = redirectUrl;
  }

  isWaitingStatus(status: number) {
    return (
      status === 1 ||
      status === 2 ||
      status === 3 ||
      status === 4 ||
      status === 5
    );
  }

  openProductDetail(product) {
    const dialogRef = this.dialog.open(OrderDetailComponent, {
      minWidth: '328px',
      maxWidth: '500px',
      width: '90%',
      panelClass: 'order-detail-dialog',
      data: { product },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.orderAgain) {
        this.retryOrder(product);
      }
    });
  }

  retryOrder(product) {
    this.router.navigate([
      '/product',
      product?.product_detail?.id,
      product?.product_detail?.name.split(' ').join('-'),
    ]);
  }

  viewOrder(id, type: number = 1) {
    this.shareLink = '';
    if (id) {
      this.panelService.getShareLink(id).subscribe((data) => {
        if (data.share_link) {
          this.shareLink = data.share_link;
          if (type == 1) {
            this.copyToClipboard(this.shareLink);
          } else {
            if (this.binanceService.isBinance) {
              window.location.href = data.share_link;
            } else {
              window.open(data.share_link, '_blank');
            }
          }
        }
      });
    }
  }

  filterByDate() {
    this.isFilterFormCalled = true;
    this.closeBottomSheet();
    this.closeDialogs();
    this.getOrderList();
  }

  copyToClipboard(data: any) {
    this.clipboard.copy(data);
    let message = 'Link copied to clipboard.';
    this.snackBarService.showSnackBar(message, 'primary', 2000);
  }

  openBottomSheet() {
    let bottomSheetRef = this.bottomSheet.open(this.filterOrdersBottomSheet, {
      panelClass: 'order-filtering-bottom-sheet',
    });

    bottomSheetRef.afterDismissed().subscribe((res) => {
      this.filterForm.reset();
    });
  }

  openFilterDialog() {
    let dialogRef = this.dialog.open(this.filterOrdersDialog, {
      panelClass: 'order-filtering-dialog',
      width: '592px',
    });

    dialogRef.afterClosed().subscribe((res) => {
      this.filterForm.reset();
    });
  }

  closeDialogs() {
    this.dialog.closeAll();
  }

  closeBottomSheet() {
    this.bottomSheet.dismiss();
  }
}
